import React, { FC, useEffect } from 'react'
import { useToggle } from '@/hooks/useToggle'
import { useTranslate } from '@/utils/translate/translate-client'
import { ExpressGuildUpsellCheckbox } from '@/views/ExpressCheckoutView/components/ExpressGuildUpsell/ExpressGuildUpsellCheckbox'
import ExpressGuildUpsellLineItems from '@/views/ExpressCheckoutView/components/ExpressGuildUpsell/ExpressGuildUpsellLineItems'
import { GuildUpsellProgressBarHorizontal } from '@/views/ExpressCheckoutView/components/ExpressGuildUpsell/GuildUpsellProgressBarHorizontal'
import { getGuildUpsellLabels } from '../../utils'

interface Props {
  projectSlug: string
  onChange: (isGuildUpsellAdded: boolean) => void
}

export const ExpressGuildUpsell: FC<Props> = ({ projectSlug, onChange }) => {
  const [isGuildMembershipAdded, toggleIsGuildMembershipAdded] = useToggle(false)
  const { t } = useTranslate('pif')

  const guildUpsellLabels = getGuildUpsellLabels(projectSlug, t)

  useEffect(() => {
    onChange(isGuildMembershipAdded)
  }, [isGuildMembershipAdded, onChange])

  return (
    <>
      <ExpressGuildUpsellCheckbox
        isChecked={isGuildMembershipAdded}
        onChange={toggleIsGuildMembershipAdded}
        projectSlug={projectSlug}
      />
      {guildUpsellLabels && (
        <GuildUpsellProgressBarHorizontal
          guildMembershipIncluded={isGuildMembershipAdded}
          pifLabel={guildUpsellLabels.pifLabel}
          guildLabel={guildUpsellLabels.guildLabel}
        />
      )}
      <ExpressGuildUpsellLineItems guildMembershipIncluded={isGuildMembershipAdded} />
    </>
  )
}
